export default __webpack_public_path__ + "static/media/Hair_16_F_C1.8ceffa25.svg";